import Link from "@/components/Link"
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from "@/components/chadcn/Breadcrumb"
import { intercalate } from "@/utils/array-utils"
import cn from "@/utils/cn"

type BreadcrumbsProps = {
  breadcrumbs: { element: React.ReactNode; href?: string }[]
  className?: string
}

const Breadcrumbs = ({ breadcrumbs, className }: BreadcrumbsProps) => (
  <Breadcrumb className={className}>
    <BreadcrumbList>
      {intercalate(
        breadcrumbs.map(({ element, href }, index) => (
          <BreadcrumbItem key={href ?? `${index} - last`}>
            <Link
              to={href ?? ""}
              className={cn(
                "text-base font-normal",
                index === breadcrumbs.length - 1
                  ? "text-primary/90"
                  : "text-primary/60",
                href === undefined && "pointer-events-none cursor-default"
              )}
            >
              {element}
            </Link>
          </BreadcrumbItem>
        )),
        (index) => (
          <BreadcrumbSeparator className="h-4" key={`separator-${index}`}>
            <span
              className={cn("material-icons text-primary/60")}
              style={{ fontSize: "16px" }}
            >
              arrow_forward_ios
            </span>
          </BreadcrumbSeparator>
        )
      )}
    </BreadcrumbList>
  </Breadcrumb>
)

export default Breadcrumbs
